module.exports = __webpack_public_path__ + "img/shuttle_disabled2.2069da23.svg";